import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import group services
import { getSites, postSite, putSite, deleteSite } from '../../services/site'

const getCurrentUser = state => state.user

export function* fetchSites() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getSites(user.token))
    yield put({
      type: actions.FETCH_SITES_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_SITES_ERROR, message: error.message })
  }
}

export function* setSite(site) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    site.payload.userMaster = JSON.parse(site.payload.userMaster)
    site.payload.userId = site.payload.userMaster.userId
    site.payload.userUid = site.payload.userMaster.userUid

    // ajusta los json
    site.payload.datetimedatajson = JSON.parse(site.payload.datetimedatajson)
    site.payload.sysdatajson = JSON.parse(site.payload.sysdatajson)
    site.payload.extradatajson = JSON.parse(site.payload.extradatajson)
    site.payload.operdatajson = JSON.parse(site.payload.operdatajson)
    site.payload.details = JSON.parse(site.payload.details)

    // agrego la empresa a sysdatajson
    site.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => putSite(user.token, site.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_SITES,
    })
  } catch (error) {
    yield put({ type: actions.SITE_ERROR, message: error.message })
  }
}

export function* addSite(site) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    console.log('payload', site.payload)
    site.payload.userMaster = JSON.parse(site.payload.userMaster)
    site.payload.userId = site.payload.userMaster.userId
    site.payload.userUid = site.payload.userMaster.userUid

    // ajusta los json
    site.payload.sysdatajson = {}

    // agrego la empresa a sysdatajson
    site.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => postSite(user.token, site.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el registro',
    })
    yield put({
      type: actions.FETCH_SITES,
    })
  } catch (error) {
    yield put({ type: actions.SITE_ERROR, message: error.message })
  }
}

export function* delSite(site) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteSite(user.token, site.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el registro',
    })
    yield put({
      type: actions.FETCH_SITES,
    })
  } catch (error) {
    yield put({ type: actions.SITE_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_SITES, fetchSites),
    takeEvery(actions.SITE_SET, setSite),
    takeEvery(actions.SITE_ADD, addSite),
    takeEvery(actions.SITE_DEL, delSite),
  ])
}
